import { FC } from 'react'

import Modal from 'views/components/UI/Modal'
import BackButton from 'views/components/UI/BackButton'
import {
  AcceptButton,
  ButtonContainer,
  ModalContent,
  ModalText,
  ModalTitle,
} from './styled'

interface ConfirmationModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmButtonText: string
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  title,
  confirmButtonText,
}) => {
  return (
    <Modal setShow={onClose} show={open} hideCloseButton>
      <ModalContent>
        <ModalTitle>{title}</ModalTitle>
        <ModalText>{message}</ModalText>
        <ButtonContainer>
          <BackButton text="Cancelar" type="button" onClick={onClose} />
          <AcceptButton onClick={onConfirm}>{confirmButtonText}</AcceptButton>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  )
}

export default ConfirmationModal
